import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate, useNavigationType } from 'hooks/useNavigate';
import { FLOW_TO_STEP_MAP, getAllowedRoutesForStatus } from 'handlers/applicationStep';
import { getApplicationStep } from 'selectors/getApplicationStep';
import { getApplicationData } from 'selectors/getApplicationData';
import { getState } from 'selectors/getState';
import { getExistingPath } from 'utils/getExistingPath';

export const useStatusRouteGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();

  const state = useSelector(getState);
  const { currentFlow } = getApplicationStep(state);
  const { application } = getApplicationData(state);

  useEffect(() => {
    if (navigationType !== 'POP' || currentFlow === undefined || !application?.status) return;

    const currentPath = getExistingPath(location.pathname);
    if (!currentPath) return;

    // Only statuses with an explicit allow-list are guarded; if the current route is already
    // allowed for the status there is nothing to do.
    const allowedRoutes = getAllowedRoutesForStatus(currentFlow, application.status);
    if (!allowedRoutes || allowedRoutes.includes(currentPath)) return;

    const expectedPath = FLOW_TO_STEP_MAP[currentFlow](application).path;
    if (expectedPath && currentPath !== expectedPath) {
      navigate(expectedPath, { replace: true });
    }
  }, [location, navigationType, currentFlow, application?.status]);
};
